import axios from 'axios';
import { REACT_APP_URL } from '../config';
const api = axios.create({
  baseURL: REACT_APP_URL,
});

export default api;
